import { AfterViewInit, Component, ViewEncapsulation, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { GlobalFuntions } from 'app/_helpers';

@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ChatbotComponent implements AfterViewInit, OnDestroy {

    // bound listener so we can remove it on destroy
    // private _onScriptLoadedBound: any;
    // private primaryColor: string = '';
    // private secondaryColor: string = '';

    constructor(private _helperFunctions: GlobalFuntions) { }

    ngAfterViewInit(): void {
        /*
        this.extractThemeColors();

        // attempt initialization and also listen for script-loaded events
        this._onScriptLoadedBound = (ev: any) => {
            // when script is appended/loaded, try to initialize immediately
            this.tryInitialize();
        };
        window.addEventListener('chatbotScriptLoaded', this._onScriptLoadedBound as EventListener);

        this.tryInitialize();
        */
    }

    /**
     * Extract theme colors from Angular Material theme
     * Creates temporary Material elements to read the actual theme color
     */
    /*
    private async extractThemeColors(): Promise<void> {
        try {
            const [primary, accent] = await Promise.all([
                this.getMaterialThemeColor('primary'),
                this.getMaterialThemeColor('accent')
            ]);

            this.primaryColor = accent;
            this.secondaryColor = primary; // primary color is lighter than accent

            // Try init again now that colors are ready
            this.tryInitialize();
        } catch (error) {
            console.warn('Failed to extract theme colors:', error);
        }
    }

    private getMaterialThemeColor(type: 'primary' | 'accent'): Promise<string> {
        return new Promise((resolve) => {
            if (typeof document === 'undefined') {
                resolve('');
                return;
            }

            try {
                const tempBtn = document.createElement('button');
                tempBtn.className = `mat-mdc-raised-button mat-${type}`;
                tempBtn.style.visibility = 'hidden';

                document.body.appendChild(tempBtn);

                // Wait for styles to apply
                setTimeout(() => {
                    const style = getComputedStyle(tempBtn);
                    const bgColor = style.backgroundColor;

                    document.body.removeChild(tempBtn);

                    if (
                        bgColor &&
                        bgColor !== 'rgba(0, 0, 0, 0)' &&
                        bgColor !== 'transparent'
                    ) {
                        resolve(this._helperFunctions.rgbToHex(bgColor));
                    } else {
                        resolve('');
                    }
                }, 100);
            } catch (err) {
                console.warn(`Could not extract ${type} color`, err);
                resolve('');
            }
        });
    }
    */

    ngOnDestroy(): void {
        /*
        if (this._onScriptLoadedBound) {
            window.removeEventListener('chatbotScriptLoaded', this._onScriptLoadedBound as EventListener);
        }
        */
    }

    /*
    private tryInitialize(): void {
        const maxAttempts = 40; // ~20s with 500ms interval
        let attempts = 0;

        const tryInit = () => {
            attempts++;

            const win: any = window as any;
            const hasJQ = typeof win.$ !== 'undefined' && typeof win.$ === 'function';
            const chatbotObj = typeof win.chatbot !== 'undefined' ? win.chatbot : null;
            const canInit = chatbotObj && typeof chatbotObj.initialize === 'function' && hasJQ;

            if (canInit) {
                try {
                    chatbotObj.initialize(environment.ChatbotAgencyKey, win.$('#chatbot'), {
                        primary_color: this.primaryColor,
                        secondary_color: this.secondaryColor,
                        delay: 1000,
                    });
                    console.log('Chatbot initialized successfully.');
                } catch (err) {
                    console.error('Error while initializing chatbot:', err);
                    // If initialization failed, we can retry a few times
                    if (attempts < maxAttempts) {
                        setTimeout(tryInit, 500);
                    }
                }
            } else {
                // If chatbot object exists but initialize is missing, log for debugging
                if (chatbotObj && typeof chatbotObj.initialize !== 'function') {
                    console.warn('window.chatbot present but initialize is not a function yet. Retrying...', chatbotObj);
                } else {
                    console.log('Chatbot or jQuery not ready, retrying...');
                }

                if (attempts < maxAttempts) {
                    setTimeout(tryInit, 500);
                } else {
                    console.error('Unable to initialize chatbot after multiple attempts.');
                }
            }
        };

        tryInit();
    }
    */
}